module.exports = __webpack_public_path__ + "img/w25b.d327ac20.jpg";